import React from "react";

import './admin-list-item.styles.scss';

export default function AuditListItem({ item, index }) {
    return (
        <li className="d-block pl-3 pb-3 border-left audit-list-item">
            <p className="d-flex justify-content-between align-items-center">
                <span>{item.userInfo ? item.userInfo.username : 'console'}</span>
                <small className="font-italic">{item.updated_at}</small>
            </p>
            <p className={`alert ${index == 0 ? 'alert-success' : 'alert-danger'}`}>{item.new_text}</p>
        </li>
    )
}